import { MAX_SPECTATORS_COUNT, SUB_MATCH_DATE_DIFF } from '@okletsplay/core';
import config from 'config/config';
import { array, date, mixed, number, object } from 'yup';
import {
  createBaseTournamentValidationSchema,
  BASE_MIN_TEAMS_VALIDATION_SHAPE,
  BASE_MAX_TEAMS_VALIDATION_SHAPE,
} from 'modules/tournaments/validators';
import { UserBalanceValidationOptions } from 'modules/payments/validators';

export const createLolTournamentValidationSchema = (options: UserBalanceValidationOptions) =>
  createBaseTournamentValidationSchema(options).shape({
    startedAt: mixed().test({
      name: 'startedAt',
      message: 'Start time must be in the future.',
      test: function (value) {
        const currentDate = new Date(Date.now());
        return currentDate?.getTime() < value?.getTime();
      },
    }),
    teamsSettings: object()
      .minTournamentPlayers(
        config.riotMinPlayersAmount,
        `Riot requires a minimum of ${config.riotMinPlayersAmount} players for League of Legends tournaments`
      )
      .shape({
        minTeams: BASE_MIN_TEAMS_VALIDATION_SHAPE,
        maxTeams: BASE_MAX_TEAMS_VALIDATION_SHAPE,
      }),
    subMatchesSettings: array().of(
      object({
        round: number().required(),
        bestOf: number().required(),
        startedAt: date().nullable(),
      })
        .matchDate(
          `Difference between two dates should be more than ${SUB_MATCH_DATE_DIFF / 3600} hours`
        )
        .required()
    ),
    spectators: array().min(0).max(MAX_SPECTATORS_COUNT),
  });
